module.exports = __webpack_public_path__ + "static/media/add-product-1.f1d51316.jpg";